<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros
    [array]="aniosDisponibles"
    [typeFilter]="Filtros.YEAR"
    [name]="'filtros.anio' | translate"
    (eventClick)="anioChange($event)"
    [click]="false"
  ></app-filters>
  <app-filters filtros
    [array]="mesesDisponibles"
    [typeFilter]="Filtros.MOUNTH"
    [name]="'filtros.mes' | translate"
    (eventClick)="mesChange($event);"
    [click]="false"
  ></app-filters>
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="quitar_filtros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <app-contenedor-elementos class="zona1" id="Zona1" #zona1Container 
      [header]="{title: gtablas ? Title + milTab1 : Title, subtitles: [ {text:Subtitulo_grafica}]}">
      @if (!gtablas) {
        <mat-icon iconos fontSet="material-icons-outlined" class="margenDer iconoMen" [ngStyle]="{'color':'gray'}"
          (click)="showDataLabel = !showDataLabel" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
          {{ showDataLabel ? 'label_off' : 'label' }}
        </mat-icon> 
      }          
      <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}" (click)="ampliar()">zoom_out_map</mat-icon>
      <mat-icon iconos [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuGB">more_vert</mat-icon>
      <mat-menu #menuGB="matMenu" xPosition="before">
        <button mat-menu-item [matMenuTriggerFor]="graficas">
          <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
          {{'menu.graficas' | translate}}
        </button>
        <button mat-menu-item [matMenuTriggerFor]="Deudores">
          <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
          <span>{{'menu.nDeudores'|translate}}</span>
        </button>
        @if (gtablas) {
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="moneda">
            <mat-icon [ngStyle]="{'color':'gray'}">paid</mat-icon>
            @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.milesUsd' | translate}}</span>}
            @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.milesMxn' | translate}}</span>}
            @if(smMoneda === 'Gs'){<span>{{ 'menu.milesGs' | translate}}</span>}
          </button>
        }          
        <mat-divider></mat-divider>
        @if (!gtablas) {
          <button mat-menu-item (click)="export_img(1)">
          <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
          <span>{{'menu.Exportar' | translate}}</span>
          </button>
        }@else {
          <button mat-menu-item (click)="export_csv()">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
        }         
      </mat-menu>
      <mat-menu #moneda="matMenu">
        <button mat-menu-item (click)="CambMon('Mil',1)">
          <span>{{'menu.miles'|translate}}</span>
        </button>
        <button mat-menu-item (click)="CambMon('Pesos',1)">
          @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.usd' | translate}}</span>}
          @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.mxn' | translate}}</span>}
          @if(smMoneda === 'Gs'){<span>{{ 'menu.gs' | translate}}</span>}
        </button>
      </mat-menu>
      <mat-menu #graficas="matMenu">
        <button mat-menu-item (click)="tablaGraf('graf',tipoGraf.BARHORIZONTAL)">{{'graf.horizontal'|translate}}</button>
        <button mat-menu-item (click)="tablaGraf('graf',tipoGraf.BAR)">{{'graf.vertical'|translate}}</button>
        <button mat-menu-item (click)="tablaGraf('tabla')">{{'graf.tabla'|translate}}</button>
      </mat-menu>
      <mat-menu #Deudores="matMenu">
        <button mat-menu-item>
          <mat-checkbox [checked]="ndeud10" (click)="$event.stopPropagation();" (change)="Ndeudores(10)">10
          </mat-checkbox>
        </button>
        <button mat-menu-item>
          <mat-checkbox [checked]="ndeud20" (click)="$event.stopPropagation();" (change)="Ndeudores(20)">20
          </mat-checkbox>
        </button>
        <button mat-menu-item>
          <mat-checkbox [checked]="ndeud30" (click)="$event.stopPropagation();" (change)="Ndeudores(30)">30
          </mat-checkbox>
        </button>
        <button mat-menu-item>
          <mat-checkbox [checked]="ndeud40" (click)="$event.stopPropagation();" (change)="Ndeudores(40)">40
          </mat-checkbox>
        </button>
        @if (!persepectiva) {
          <button mat-menu-item>
            <mat-checkbox [checked]="ndeud50" (click)="$event.stopPropagation();" (change)="Ndeudores(50)">50
            </mat-checkbox>
          </button>
        }          
      </mat-menu>
      <div body class="zonaGraf">
        @if (dataSource.length === 0) {<app-skeleton-grafica />}
        @else {
          @if (gtablas) {
            <div class="w3-scroll">
              <table class="tabla-aleema">
                <thead>
                  <tr class="w3-center">
                    <th>{{'riesgo-credito.mayores.enc1'|translate}}</th>
                    <th>{{'riesgo-credito.mayores.enc2'|translate}}</th>
                    <th>{{'riesgo-credito.mayores.enc3'|translate}}</th>
                    <th>{{'riesgo-credito.mayores.enc4'|translate}}</th>
                  </tr>
                </thead>                    
                <tbody>
                  @for (element of dataSource; track $index) {
                    <tr>
                      <td> {{element.position}}</td>
                      <td> {{element.clave}}</td>
                      <td> {{element.name}}</td>
                      <td> {{smMoneda}} {{element.weight}}</td>
                    </tr>
                  }
                </tbody>                    
              </table>
            </div>
          }@else {
            <app-graficador 
              [etiquetas]="showDataLabel"
              [data]="multi2"
              [labels]="etiquetas"
              [formatEtiquetas]="true"
              [type]="tipoSelec"
              [axisX]="xAxisLabel"
              [axisY]="yAxisLabel"
              [zona]="1"
              [colors]="colorScheme2"
              (eventClick)="onSelect($event)"
              [legend]="{enabled: false, position:'right'}"
            ></app-graficador>
          }  
        }
      </div>
    </app-contenedor-elementos>
    <div class="zona2">
      <!--Zona de las Tarjetas-->
      <div class="tarjeta">
        @if(total){
          <app-tarjetas [header]="'riesgo-credito.mayores.tarj1'|translate" [valueStr]="smMoneda + ' ' + (total | formaterNumber:0:',':'.')" 
          [footer]="mesAnio" [showIcon]="false" [color]="'#0075C9'" [alto]="'14vh'" [siceValue]="'3vh'"/>
        }@else{<app-skeleton-card/>}
      </div>
      <div class="tarjeta">
        @if(suma){
          <app-tarjetas [header]="'riesgo-credito.mayores.tarj2'|translate" [valueStr]="(PorcentajeTot(suma)) + ' %'"
          [footer]="mesAnio" [showIcon]="false" [color]="'#0075C9'" [alto]="'14vh'" [siceValue]="'3vh'"/>
        }@else{<app-skeleton-card/>}            
      </div>    
      <div class="tarjeta">
        @if(suma){
          <app-tarjetas [header]="Mayores_deudores" [valueStr]="smMoneda + ' ' + (suma | formaterNumber:0:',':'.')" 
          [footer]="mesAnio" [showIcon]="false" [color]="'#0075C9'" [alto]="'14vh'" [siceValue]="'3vh'"/>
        }@else{<app-skeleton-card/>}
      </div>
      <app-contenedor-elementos class="zonaGrafica"
        [header]="{title: ('riesgo-credito.mayores.titTab' | translate) + ' ' + Mayores_deudores, subtitles: [ {text:mesAnio}]}">
        @if (!tablaPie) {
          <mat-icon iconos class="material-icons-outlined margenDer iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="showLabelsPie = !showLabelsPie" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
            {{ showLabelsPie ? 'label_off' : 'label' }}
          </mat-icon>           
        }       
        @if(!tablaPie){
          <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}" (click)="ampliarG2()" 
            onclick="">zoom_out_map</mat-icon>
        }       
        <mat-icon iconos [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuG3">more_vert</mat-icon>
        <mat-menu #menuG3="matMenu" xPosition="before">
          <button mat-menu-item [matMenuTriggerFor]="graficas3">
            <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
            {{'menu.graficas' | translate}}
          </button>
          <mat-divider></mat-divider>
          @if(tablaPie){
            <button mat-menu-item (click)="exportSaldos()">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.exportar' | translate}}</span>
            </button>
          }@else {
            <button mat-menu-item (click)="export_img(2)">
              <mat-icon fontSet="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.exportar' | translate}}</span>
            </button>
          }
        </mat-menu>
        <mat-menu #graficas3="matMenu">
          <button (click)="tablaGraf2('graf',tipoGraf.DONUT)" mat-menu-item>{{'graf.pie' | translate}}</button>
          <!-- <button (click)="tablaGraf2('graf',tipoGraf.BARHORIZONTAL)" mat-menu-item>{{'graf.horizontal' | translate}}</button> -->
          <button (click)="tablaGraf2('graf',tipoGraf.BAR)" mat-menu-item>{{'graf.vertical' | translate}}</button>
          <button (click)="tablaGraf2('tabla')" mat-menu-item>{{'graf.tabla' | translate}}</button>
        </mat-menu>
        <div body class="grafica">
          @if(datosTablaPie.length === 0){<app-skeleton-grafica/>}
          @else{
            @if (tablaPie) {
              <div class="w3-scroll">
                <table class="tabla-aleema">
                  <thead>
                    <tr class="w3-center">
                      <th>{{'riesgo-credito.mayores.titTab1'|translate}}</th>
                      <th>{{'riesgo-credito.mayores.titTab2'|translate}}</th>
                      <th>{{'riesgo-credito.mayores.titTab3'|translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (element of datosTablaPie; track $index) {
                      <tr>
                        <td> {{element.name}}</td>
                        <td class="alinRight"> {{smMoneda}} {{element.value}}</td>
                        <td class="alinRight"> {{element.porcen}}%</td>
                      </tr>
                    }  
                  </tbody>                      
                </table>
              </div>              
            }@else {
              <app-graficador 
                [etiquetas]="showLabelsPie"
                [data]="datos_pie"
                [labels]="etiquetasPie"
                [type]="tipoSelec2"
                [axisX]="xAxisLabel"
                [axisY]="yAxisLabel"
                [zona]="2"
                [colors]="colorSchemePie"
                [porcentaje]="true"
                [formatEtiquetas]="false"
                [legend]="{enabled: true, position: 'bottom'}"
              ></app-graficador>
            }
          }  
        </div>
      </app-contenedor-elementos>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalOpen" (close)="cerrarAmp()" [export]="true" [iconoExport]="iconoExportar"
  [labels]="labelsModal" [labelsState]="showLabels()" (changeLables)="changeLabels()" (exportFile)="exportarModal()">
  <div modal-header>
    <span class="w3-margin-left-contenido">{{titleModal}} </span>
    <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
    <span class=" w3-margin-left-filter w3-subtitulo">{{ subtitleModal }}</span>
  </div>
  <div modal-body style="height: 60vh; width: 70vw; overflow-y: hidden;">
    <div style="width: 100%; height: 100%;">
      <!-- grafica tabla zona 1 -->
      @if (gMayoresModal) {
        <app-graficador 
          [etiquetas]="showDataLabel"
          [data]="multi2"
          [labels]="etiquetas"
          [type]="tipoSelec"
          [axisX]="xAxisLabel"
          [axisY]="yAxisLabel"
          [zona]="3"
          [colors]="colorScheme2"
          [formatEtiquetas]="true"
          [legend]="{enabled: false, position: 'right'}"
        ></app-graficador>
      }
      @if (gtablasModal) {
        <div class="w3-scroll" style="height: 100%;">
          <table class=" w3-table">
            <thead>
              <tr class="w3-table-titleLow w3-center">
                <td class="encabezados w3-border-right-balance alinCen stikyColum">{{'riesgo-credito.mayores.enc1'|translate}}</td>
                <td class="encabezados w3-border-right-balance alinCen stikyColum">{{'riesgo-credito.mayores.enc2'|translate}}</td>
                <td class="encabezados w3-border-right-balance alinCen stikyColum">{{'riesgo-credito.mayores.enc3'|translate}}</td>
              </tr>
            </thead>
            @for (element of dataSource; track $index) {
              <tbody class="borderInf borderIzq">
                <tr class="w3-table-trtd">
                  <td class="borderAllLow marginsH"> {{element.position}}</td>
                  <td class="borderAllLow marginsH"> {{element.name}}</td>
                  <td class="borderAllLow marginsH"> {{smMoneda}} {{element.weight}}</td>
                </tr>
              </tbody>
            }
          </table>
        </div>
      }
      <!-- grafica tabla zona 2  -->
      @if (gCarteraModal) {
        <app-graficador 
          [etiquetas]="showLabelsPie"
          [data]="datos_pie"
          [labels]="etiquetasPie"
          [type]="tipoSelec2"
          [axisX]="xAxisLabel"
          [axisY]="yAxisLabel"
          [zona]="4"
          [colors]="colorSchemePie"
          [formatEtiquetas]="false"
          [porcentaje]="true"
          [legend]="{enabled: true, position: 'bottom'}"
        ></app-graficador>
      }      
    </div>
  </div>
</app-modal>